/* eslint-disable no-unused-expressions */
import React from 'react';
import { useLocation } from 'react-router-dom';
import {setupControlData} from '../ManageControlCommons/ManageControlCommons';
import './ControlDetailInfo.css';
import Input from '.././Input/Input';
import clsx from 'clsx';
import {formatSubject, isPlanowana} from "../ControlStateHelper";
import {draftjsToHTML} from '../WysiwygEditor/WysiwygHelpers';

export const ControlDetailInfo = props => {
	const location = useLocation();
	const isControlDetail = location.pathname.startsWith('/controls/control_detail') || location.pathname.startsWith('/my_controls/control_detail') || location.pathname.startsWith('/post_control/control_detail');

	const controlInfoItem = (label, value, isChecklistVersion, checklistVersionInfo) => {

		const controlInfoItemClassNameClsx = clsx(
			isChecklistVersion != null ? 'col-md-6' : 'col-md-9'
		  );

		return (<div className='row mt-3'>
			<div className='col-md-3 input-label'>{label}:</div>
			<div className={controlInfoItemClassNameClsx}>{value}{checklistVersionInfo ? (', ' + checklistVersionInfo) : ''}</div>
			{isChecklistVersion != null && (
				<Input
					labelClassName='sr-only'
					label='Wersja'
					inputId='checklistVersion'
					value={props.checklistVersion}
					onChange={ (e) => {props.handleChangeChecklistVersion(e.target.value)} }
					chartsCount={props.checklistVersion?.length}
					maxLength={8}
					disabled={props.isSectionEdit != null && !props.isSectionEdit("controlInfo")}
				/>
			)}
		</div>)
	};

	const prepareControlData = (item) => {
		//if(item.controlledParty && item.controlledParty !== null) {item.controlledPartyName = item.controlledParty.name}
		item.controlKind = '';
		item.controlTeam = '';
		item.controlWop = '';
		item.controlOrder = '';
		item.allControlledParties = '';
		item.dictionaryEntries.forEach(function (entry) {
			if (entry.dictNumber === 1) {
				item.controlType = entry.description;
			}
			if (entry.dictNumber === 2) {
				item.controlMode = entry.description;
			}
			if (entry.dictNumber === 3) {
				item.controlKind += entry.description + ', ';
			}
		});
		item.controlKind = item.controlKind.slice(0,-2);
		setupControlData(item);

		if (item.controlledParties && item.controlledParties.length > 0) {
			item.controlledParties.forEach(function (sub, index) {
				item.allControlledParties += formatSubject(sub.idType, sub.name, sub.nip, sub.pesel, sub.foreignNumber);
				if (index < item.controlledParties.length - 1)
					item.allControlledParties += ', '
			})
		}
		if (item.orders && item.orders.length > 0) {
			item.orders.forEach(function (entry, index) {
				index < item.orders.length - 1 ? item.controlOrder += entry.order + ', ' : item.controlOrder += entry.order;
			})
		}
		if (item.paymentClaims && item.paymentClaims.length > 0) {
			item.paymentClaims.forEach(function (entry, index) {
				index < item.paymentClaims.length - 1 ? item.controlWop += entry.number + ', ' : item.controlWop += entry.number;
			})
		}
		return item;
	};

	const printPickedParties = (control) => {
		let partiesCollection = control.controlledParties;
		if (partiesCollection.length > 0) {
			let pickedParties = [];
			partiesCollection.forEach(function (item, index) {
				let val = <p className='my-3' key={index} array-key={index}><span className='added-item'>{formatSubject(item.idType, item.name, item.nip, item.pesel, item.foreignNumber)}</span></p>;
				pickedParties.push(val);
			});
			return pickedParties;
		} else {
			return <p>Brak podmiotów kontrolowanych</p>
		}
	};

	const printPickedPlaces = (control) => {
		let placesCollection = control.controlPlaces;
		if (placesCollection.length > 0) {
			let pickedPlaces = [];
			placesCollection.forEach(function (item, index) {
				let val = <p className='my-3' key={index} array-key={index}><span className='added-item'>{item.name}</span></p>;
				pickedPlaces.push(val);
			});
			return pickedPlaces;
		} else {
			return <p>Brak miejsc przeprowadzenia kontroli</p>
		}
	};

	const printPickedOtherProjects = (control) => {
		let projectsCollection = control.otherControlledProjectNumbers || [];
		if (projectsCollection.length > 0) {
			let pickedProjects = [];
			projectsCollection.forEach(function (item, index) {
				let val = <p className='my-3' key={index} array-key={index}><span className='added-item'>{item}</span></p>;
				pickedProjects.push(val);
			});
			return pickedProjects;
		} else {
			return <p>Brak innych kontrolowanych projektów</p>
		}
	};

	const printPickedOrders = (control) => {
		if (control.orders?.length > 0) {
			const headers = 
				<div className='row' style={{marginTop: '1rem'}}>
					<div className='col'><b>Numer ogłoszenia o zamówieniu</b></div>
					<div className='col'><b>Nazwa zamówienia</b></div>
					<div className='col'><b>Kontrakty</b></div>
				</div>
			return [headers, ...control.orders.map((item) =>
				<div className='row' style={{marginTop: 10, wordBreak: 'break-word'}} key={item?.uuid}>
					<div className='col'>{item?.orderNumber}</div>
					<div className='col'>{item?.orderName}</div>
					<div className='col'>{item?.contracts}</div>
				</div>
			)];
		} else {
			return <p>Brak kontrolowanych zamówień</p>
		}
	};

	const printPickedWops = (control) => {
		let wopsCollection = control.paymentClaims;
		if (wopsCollection.length > 0) {
			let pickedWops = [];
			wopsCollection.forEach(function (item, index) {
				let val = <p className='my-3' key={index} array-key={index}><span
					className='added-item'>{item.number}</span></p>;
				pickedWops.push(val);
			});
			return pickedWops;
		} else {
			return <p>Brak kontrolowanych wniosków</p>
		}
	};

	const printRemarks = (control) => {
		if (control.remarks) {
			return <div dangerouslySetInnerHTML={{ __html: draftjsToHTML(control.remarks) }} />;
		} else {
			return <p>Brak uwag</p>
		}
	};

	const renderControlInfo = (control) => {
		prepareControlData(control);
    return <div>
      <h4 className='mt-5'>Informacje o projekcie: </h4>
      <div className='row'>
        <div className='col-md-12'>
          {controlInfoItem('Numer kontroli', control.number)}
          {controlInfoItem('Numer projektu', control.project.metadata.businessId)}
          {controlInfoItem('Tytuł projektu', control.project.title)}
        </div>
      </div>
      <h4 className='mt-5'>Dane beneficjenta: </h4>
      <div className='row'>
        <div className='col-md-12'>
          {controlInfoItem('Identyfikator beneficjenta', control.project.beneficiaryIdentityNumber)}
          {controlInfoItem('Nazwa beneficjenta', control.project.beneficiaryName)}
          {controlInfoItem('Adres beneficjenta', control.project.beneficiaryAddress)}

        </div>
      </div>
      <h4 className='mt-5'>Informacje o kontroli: </h4>
      <div className='row'>
        <div className='col-md-12'>
          {controlInfoItem('Tryb kontroli', control.controlMode)}
          {controlInfoItem('Typ kontroli', control.controlType)}
          {controlInfoItem('Rodzaj kontroli', control.controlKind)}
          {controlInfoItem('Zespół kontrolujący', control.controlTeam)}
          {controlInfoItem('Zastosowana lista sprawdzająca', control.questionList.name, props.checklistVersion, props.checklistVersionInfo)}
			{controlInfoItem('Planowany termin kontroli', control.plannedTerm)}
			{!isPlanowana(control) && controlInfoItem('Data rozpoczęcia kontroli', control.term)}
        </div>
      </div>
      {!props.noControlledItems ?

        (<div>
          { controlInfoItem('Podmiot kontrolujący', control.controllingEntity ? control.controllingEntity : 'Brak podmiotu kontrolującego')}<br/>

          <div className='controlListBlocks'>
            <h4 className='mt-4'>Podmioty kontrolowane:</h4>
            {printPickedParties(control)}
          </div>

          <div className='controlListBlocks'>
            <h4 className='mt-4'>Miejsca przeprowadzenia kontroli:</h4>
            {printPickedPlaces(control)}
          </div>

          <div className='controlListBlocks'>
            <h4 className='mt-4'>Inne kontrolowane projekty:</h4>
            {printPickedOtherProjects(control)}
          </div>

          <div className='controlListBlocks'>
            <h4 className='mt-4'>Kontrolowane zamówienia:</h4>
            {printPickedOrders(control)}
          </div>
          <div className='controlListBlocks'>
            <h4 className='mt-4'>Numery kontrolowanych WoP:</h4>
            {printPickedWops(control)}
          </div>
          {isControlDetail && <div className='controlListBlocks'>
            <h4 className='mt-4'>Uwagi:</h4>
            {printRemarks(control)}
          </div>}
        </div>) : null}


    </div>;
	};

	let controlInfo = props.control;
	return (
		<div>
			{renderControlInfo(controlInfo)}
		</div>
	);
};
